import { render } from "./MultiButton.vue?vue&type=template&id=74a08ca6"
import script from "./MultiButton.vue?vue&type=script&lang=js"
export * from "./MultiButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__